import { render, staticRenderFns } from "./AreaBioView.vue?vue&type=template&id=dfd99386&scoped=true"
import script from "./AreaBioView.vue?vue&type=script&lang=js"
export * from "./AreaBioView.vue?vue&type=script&lang=js"
import style0 from "./AreaBioView.vue?vue&type=style&index=0&id=dfd99386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd99386",
  null
  
)

export default component.exports